import { Checkbox } from "antd";
import styled, { css } from "styled-components";

import colors from "../../../themes/colors";

const dropdownWidth = 230;

/**
 * Custom Menu
 */

export const ButtonGroup = styled.div`
  display: flex;
  padding: 0 10px;
  button {
    margin: 0px;
  }
  &.space-between {
    justify-content: space-between;
  }
`;

export const OptionsWrapper = styled.div`
  width: ${dropdownWidth}px;
  padding: 0 10px;
  max-height: 200px;
  overflow-y: scroll;
`;

/**
 * The option list. While an exclusive quick filter is active it is rendered
 * muted (`$muted`) so it reads as inactive, but it stays clickable on purpose:
 * clicking an option is how you get back out of the quick filter, and antd's
 * own `disabled` would swallow that click. Only the labels are greyed — the
 * checkbox boxes keep their normal colours so a tick stays legible.
 *
 * Styled rather than wrapped in a div because `CustomMenu` reaches into its
 * second child to apply the type-to-filter box; an extra wrapper element would
 * break that.
 */
export const OptionGroup = styled(Checkbox.Group)<{ $muted?: boolean }>`
  ${({ $muted }) =>
    $muted &&
    css`
      .ant-checkbox-wrapper > span:not(.ant-checkbox) {
        color: ${colors.darkGrey};
      }
    `}
`;

export const CustomMenuWrapper = styled.div`
  padding: 10px 0;
  background-color: ${colors.white};
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 2px;
`;
